import { LOCATION_INITIALIZED } from '@angular/common';
import { Injector } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { noop } from 'rxjs';

export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () =>
    new Promise<unknown>((resolve: (value: unknown) => void) => {
      const getLocation = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
      getLocation.then(() => {
        const defaultLang = 'en-GB';
        translate.setDefaultLang(defaultLang);
        translate.use(defaultLang).subscribe(
          noop,
          (err: unknown) => {
            console.error('Translation service initialization failed', err);
          },
          () => resolve(null)
        );
      });
    });
}
